import React from "react";
import { Table } from "antd";
import styled from "styled-components";

const StyledTable = styled(Table)`
	.ant-table {
		border-radius: 10px;
		overflow: hidden;
		border: 1px solid var(--lcds-border);
	}
	.ant-table-thead > tr > th {
		background: var(--lcds-navy);
		color: #fff;
		font-weight: 600;
		font-size: 13px;
		letter-spacing: 0.02em;
		border-bottom: 0;
		&::before {
			display: none;
		}
	}
	.ant-table-tbody > tr > td {
		font-size: 14px;
		border-bottom: 1px solid var(--lcds-border);
	}
	.ant-table-tbody > tr:nth-child(even) > td {
		background: #fafbfc;
	}
	.ant-table-tbody > tr:hover > td {
		background: #eefafa !important;
	}
	.ant-pagination {
		margin: 20px 0 0;
	}
	/* Nested table shown in an expanded row (results steps / fire-ext attempts). */
	.ant-table-expanded-row > td {
		background: #f3f6f7;
		padding: 12px 16px 16px 56px;
	}
	/* antd pulls a nested table flush with -16px margins; with overflow-x:auto on the
	   wrapper that clipped the inner table, so reset it. */
	.ant-table-expanded-row .ant-table-wrapper:only-child .ant-table,
	.ant-table-expanded-row .ant-table {
		margin: 0;
		border-radius: 6px;
	}
	.ant-table-expanded-row .ant-table-thead > tr > th {
		background: #e3e9ec;
		color: var(--lcds-text);
		font-size: 12px;
	}
	.ant-table-expanded-row .ant-table-tbody > tr > td {
		font-size: 13px;
		background: #fff;
	}
`;

/**
 * Table with server-side pagination.
 * `pagination` = { page, pageSize, total, onChange(page, pageSize) }.
 */
const DataTable = ({ rows, columns, loading, pagination, rowKey = "id", ...rest }) => (
	<StyledTable
		scroll={{ x: "max-content" }}
		rowKey={rowKey}
		loading={loading}
		dataSource={rows}
		columns={columns}
		pagination={
			pagination
				? {
						current: pagination.page,
						pageSize: pagination.pageSize,
						total: pagination.total,
						showSizeChanger: true,
						pageSizeOptions: ["10", "20", "50", "100"],
						showTotal: (total, range) => `${range[0]}-${range[1]} of ${total}`,
						onChange: pagination.onChange,
				  }
				: false
		}
		{...rest}
	/>
);

export default DataTable;
